// Copied from apps/admin/src/features/map-view/model/geo-distance.ts (PRD #875).
// Leaflet-free on purpose: data hooks (the TTN's GPS derivation) use it too.

export const METERS_PER_DEGREE_LAT = 111_320;

/** Planar distance in metres between two nearby points: fine at yard scale. */
export const distanceMeters = (latA: number, lonA: number, latB: number, lonB: number) =>
  Math.hypot(
    (lonB - lonA) * METERS_PER_DEGREE_LAT * Math.cos((latA * Math.PI) / 180),
    (latB - latA) * METERS_PER_DEGREE_LAT,
  );
